import * as bootstrap from 'bootstrap';
import $ from 'jquery';

import api from "./ajax";
import renderSubContractorRows from "./render-sub-contractor-row";

const AdditionalTipping = () => {
	const additionalTippingTable = document.getElementById('additionalTippingTable');

	// Check the table exists
	if (!additionalTippingTable) {
		return;
	}

	const addTruckBtn = document.getElementById('addTippingTruck');

	const truckTypes = JSON.parse(document.getElementById('truckTypes').textContent);

	let tippingRate = parseFloat(additionalTippingTable.getAttribute('data-rate') || 0).toFixed(2);

	// Get job material from data attribute or default to empty string
	const jobMaterial = additionalTippingTable.getAttribute('data-material') || '';

	const tippingRateInput = document.getElementById('tippingRateInput');

	const tbody = additionalTippingTable.querySelector('tbody');

	const observerCallback = (mutationsList, observer) => {
		for (let mutation of mutationsList) {
			if (mutation.type === 'childList') {
				updateIndices();
				calculateGrandTotal();
			}
		}
	};

	const observer = new MutationObserver(observerCallback);
	const config = { childList: true };

	// Start observing
	observer.observe(tbody, config);

	const renderRow = (truck, index) => {
		const truckType = truck ? truck.truckType : '';
		const truckId = truck ? truck.truckId : '';
		const vehicleReg = truck ? truck.vehicleReg : '';
		const renderTrucks = truckTypes.map(truck => `<option value="${truck.key}" ${truck.key === truckType ? 'selected' : ''}>${truck.name}</option>`).join('');
		const truckSize = truck ? truck.truckSize : 0;
		const loads = truck ? truck.loads : 0;
		const measurementUnit = truck ? truck.measurementUnit : 'm3';
		const rate = truck && truck.rate ? truck.rate : tippingRate;
		const material = truck && truck.material ? truck.material : jobMaterial;
		const total = truck ? (truckSize * loads * rate).toFixed(2) : '0.00';
		const hiddenId = truckId ? `<input type="hidden" name="trucks[${index}][id]" value="${truckId}">` : '';

		return `<tr id="tippingItem${index}" data-id="${truckId}" class="editable">
                <td style="width: 12%;">
                    <div class="form__group">
                        <input class="form__control" required type="text" name="trucks[${index}][vehicle_registration]" value="${vehicleReg}">
                        ${hiddenId}
                    </div>
                </td>
                <td style="width: 15%;">
                    <div class="form__group">
                        <select class="form__control" required name="trucks[${index}][truck_type]">
                            <option value="">Select a truck</option>
                            ${renderTrucks}
                        </select>
                    </div>
                </td>
                <td style="width: 15%;">
                    <div class="form__group">
                        <input class="form__control" type="text" name="trucks[${index}][material]" value="${material}">
                    </div>
                </td>
                <td style="width: 15%;">
                    <div class="form__input-group">
                        <input class="form__control" required type="number" step="1" name="trucks[${index}][truck_size]" value="${truckSize}" style="border-right: none; border-top-right-radius: 0; border-bottom-right-radius: 0;">
                        <select class="form__control" required name="trucks[${index}][measurement_unit]" style="max-width: 100px; border-left: none; border-right: 1px solid #B9B9B9; border-top-left-radius: 0; border-bottom-left-radius: 0; background: var(--bs-tertiary-bg);">
                            <option value="m3" ${measurementUnit === 'm3' ? 'selected' : ''}>M3</option>
                            <option value="tonne" ${measurementUnit === 'tonne' ? 'selected' : ''}>TONNE</option>
                        </select>
                    </div>
                </td>
                <td style="width: 8%;">
                    <div class="form__group">
                        <input class="form__control" required type="number" name="trucks[${index}][loads]" value="${loads}">
                    </div>
                </td>
                <td>
                    <div class="form__group">
                        <input class="form__control rate-input" required type="number" step="0.01" name="trucks[${index}][rate]" value="${rate}" style="width: 80px;">
                    </div>
                </td>
                <td class="total">$${total}</td>
                <td>
                    <div class="options-menu">
                        <button id="tippingMenuButton${index}" type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown">
                            <i class="far fa-ellipsis-h"></i>
                        </button>
                        <ul class="dropdown-menu">
                            <li>
                                <a class="dropdown-item danger" href="#confirmRemoveTippingModal" data-bs-toggle="modal" data-ref="tippingItem${index}" data-rego="${vehicleReg}">
                                    Delete
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
            </tr>`;
	}

	const editRow = (rowId) => {
		const row = document.getElementById(rowId);
		if (!row) return;

		// Extracting values directly from the table row's cells
		const vehicleReg = row.cells[0].textContent.trim();
		const truckType = row.cells[1].getAttribute('data-value').trim();
		const material = row.cells[2].getAttribute('data-material')?.trim() || row.cells[2].textContent.trim();
		const truckSizeText = row.cells[3].textContent.trim();
		const measurementUnit = row.cells[3].getAttribute('data-measurement').trim();
		const loads = row.cells[4].textContent.trim();
		const rate = row.cells[5].getAttribute('data-rate')?.trim() || row.cells[5].textContent.replace('$', '').trim();
		const truckId = row.getAttribute('data-id');

		// Extract truck size from the combined text (e.g., "10 M3" -> "10")
		const truckSize = truckSizeText.split(' ')[0];

		const truckData = {
			truckId,
			vehicleReg,
			truckType,
			material,
			truckSize,
			measurementUnit,
			loads,
			rate
		};

		const rowIndex = Array.from(row.parentNode.children).indexOf(row);
		const editableRowHtml = renderRow(truckData, rowIndex);

		row.outerHTML = editableRowHtml;  // Replace with editable version

		row.outerHTML = editableRowHtml;  // Replace the entire row with an editable version

		updateIndices();
	}

	const updateIndices = () => {
		const rows = additionalTippingTable.querySelectorAll('tbody tr.editable');

		for (let i = 0; i < rows.length; i++) {
			const rowId = rows[i].querySelector('input[name*="[id]"]');
			rowId ? rowId.name = `trucks[${i}][id]` : null;
			rows[i].querySelector('input[name*="[vehicle_registration]"]').name = `trucks[${i}][vehicle_registration]`;
			rows[i].querySelector('select[name*="[truck_type]"]').name = `trucks[${i}][truck_type]`;
			rows[i].querySelector('input[name*="[material]"]').name = `trucks[${i}][material]`;
			rows[i].querySelector('input[name*="[truck_size]"]').name = `trucks[${i}][truck_size]`;
			rows[i].querySelector('select[name*="[measurement_unit]"]').name = `trucks[${i}][measurement_unit]`;
			rows[i].querySelector('input[name*="[loads]"]').name = `trucks[${i}][loads]`;
			rows[i].querySelector('input[name*="[rate]"]').name = `trucks[${i}][rate]`;
		}
	}

	const prefillTruckSizeOnChange = (e) => {

		// Get the value of the selected option
		const selectedTruckType = e.target.value;

		// Get the parent row
		const row = e.target.parentNode.parentNode.parentNode;

		// Get the truck size input of the current row
		const truckSizeInput = row.querySelector('input[name*="[truck_size]"]');


		if (!selectedTruckType) {
			// Set the truckSize input value to 0
			truckSizeInput.value = 0;
		}

		// Get the size from the truckTypes array matching selectedTruckType to the key
		truckTypes.forEach(truck => {
			if (truck.key === selectedTruckType) {
				truckSizeInput.value = truck.size;
			}
		});

		calculateCosts(e);
	}

	const calculateCosts = (e) => {
		// Get the row - handle both input-group and form__group structures
		let row = e.target.closest('tr');
		const truckSize = parseFloat(row.querySelector('input[name*="[truck_size]"]').value) || 0;
		const loads = parseFloat(row.querySelector('input[name*="[loads]"]').value) || 0;
		const rate = parseFloat(row.querySelector('input[name*="[rate]"]').value) || 0;
		const totalCost = row.querySelector('.total');

		const cost = (truckSize * loads * rate).toFixed(2);
		totalCost.textContent = `$${cost}`;

		calculateGrandTotal();
	}

	const calculateGrandTotal = () => {
		const grandTotalEl = document.getElementById('tippingGrandTotal');
		// Get all elements with class total from the table and sum them
		const totalCosts = Array.from(additionalTippingTable.getElementsByClassName('total'));
		const grandTotal = totalCosts.reduce((acc, el) => {
			return acc + parseFloat(el.textContent.replace('$', ''));
		}, 0).toFixed(2);

		grandTotalEl.textContent = `$${grandTotal}`;
	}

	const onTippingTableChange = (e) => {
		if (event.target.matches('select[name*="[truck_type]"]')) {
			prefillTruckSizeOnChange(e);
		} else if (event.target.matches('input[name*="[truck_size]"]')) {
			calculateCosts(e);
		} else if (event.target.matches('input[name*="[loads]"]')) {
			calculateCosts(e);
		} else if (event.target.matches('input[name*="[rate]"]')) {
			calculateCosts(e);
		} else if (event.target.matches('input[name*="[vehicle_registration]"]')) {
			onRegistrationChange(e);
		}
	};

	const onRegistrationChange = (e) => {
		const row = e.target.parentNode.parentNode.parentNode;
		const truckRego = row.querySelector('input[name*="[vehicle_registration]"]').value;

		// Find the child href="#confirmRemoveContractorModal" of the row
		const deleteButton = row.querySelector('a[href="#confirmRemoveTippingModal"]');

		// Update the data-name attribute of the delete button
		deleteButton.setAttribute('data-rego', truckRego);
	}

	const recalculateAllCosts = () => {
		// Update the tipping rate variable
		tippingRate = parseFloat(tippingRateInput.value || 0).toFixed(2);

		// Recalculate all row totals
		const rows = additionalTippingTable.querySelectorAll('tbody tr');
		rows.forEach(row => {
			const truckSizeInput = row.querySelector('input[name*="[truck_size]"]');
			const loadsInput = row.querySelector('input[name*="[loads]"]');
			const totalCell = row.querySelector('.total');
			const rateCell = row.cells[4]; // Rate column

			if (truckSizeInput && loadsInput && totalCell) {
				const truckSize = parseFloat(truckSizeInput.value || 0);
				const loads = parseFloat(loadsInput.value || 0);
				const cost = (truckSize * loads * tippingRate).toFixed(2);
				totalCell.textContent = `$${cost}`;

				// Update rate display for editable rows
				if (rateCell) {
					rateCell.textContent = `$${tippingRate}`;
				}
			}
		});

		calculateGrandTotal();
	};

	addTruckBtn.addEventListener('click', () => {
		const tableBody = additionalTippingTable.querySelector('tbody');
		const rowCount = tableBody.rows.length;
		const newRow = renderRow(null, rowCount);
		tableBody.insertAdjacentHTML('beforeend', newRow);

	});

	// Add event listener for tipping rate changes
	if (tippingRateInput) {
		tippingRateInput.addEventListener('input', recalculateAllCosts);
		tippingRateInput.addEventListener('change', recalculateAllCosts);
	}

	// Add event listener on change for additionalTippingTable select[name*="[truck_type]"]'
	// to calculate the total cost of tipping for each truck
	additionalTippingTable.addEventListener('change', onTippingTableChange);

	additionalTippingTable.addEventListener('click', (event) => {
		if (event.target.matches('[data-action="edit-tipping"]')) {
			const button = event.target;
			const ref = button.getAttribute('data-ref');
			const rego = button.getAttribute('data-rego');
			editRow(ref, rego);
		}
	});

}

export default AdditionalTipping;